import React, { lazy, Suspense, useMemo } from "react";
import PropTypes from "kf-proptypes/widgets";

export function LazyLoadComponent(props) {
  const { component, componentName, loader, error, innerRef, ...rest } = props;

  const LazyLoadedComponent = useMemo(function memoizedComponent() {
    return lazy(() =>
      component().then((module) => {
        return { default: module[componentName || "default"] };
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.warn(error);

  return (
    <Suspense fallback={loader || null}>
      <LazyLoadedComponent {...rest} ref={innerRef} />
    </Suspense>
  );
}

LazyLoadComponent.propTypes = {
  component: PropTypes.func.isRequired,
  componentName: PropTypes.string.isRequired,
  loader: PropTypes.node,
  error: PropTypes.node,
  innerRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }).isRequired
};

export function lazyLoad({ component, componentName }) {
  const loadComponent = () =>
    component().then((module) => {
      return { default: module[componentName || "default"] };
    });
  const LazyLoadedComponent = lazy(loadComponent);
  LazyLoadedComponent.preload = loadComponent();
  LazyLoadedComponent.displayName = componentName;
  return LazyLoadedComponent;
}

export { DeferComponent } from "./defer.component.jsx";
